import { Modal, ModalProps } from "ui";

import InterestForm from "./InterestForm";

type ModalPropsWithoutChildren = Omit<ModalProps, "children">;

const InterestFormModal = (props: ModalPropsWithoutChildren) => (
  <Modal rawStyle {...props}>
    <InterestForm noMargin />
  </Modal>
);

export default InterestFormModal;
